export default {
  surveyBuilder: {
    addNewSurvey: "Nieuwe enquête toevoegen",
    surveyTitle: "Enquêtetitel",
    surveyName: "Naam enquête",
    surveyDescription: "Enquêtebeschrijving",
    describeSurvey: "Beschrijf de enquête",
    enableScheduling: "Planning inschakelen",
    enableSchedulingInfo:
      "Mogelijkheid om een specifieke datum of tijd voor de beoordeling in te stellen.",
    selectedDate: "Geselecteerde datum",
    multiStepSurvey: "Meerstaps enquête",
    multiStepSurveyDetails:
      "Afhankelijk van het aantal vragen in elke stap, worden alle vragen in de enquête gegroepeerd en weergegeven per stap.",
    multiStep: "Meerstaps",
    noQuestionEachStep: "Aantal vragen per stap",
    surveyStatus: "Enquêtestatus",
    surveyStatusDetails:
      "De enquête kan alleen worden ingeschakeld nadat vragen zijn toegevoegd. Inschakelen van de enquête stelt boeren in staat hun antwoorden in te dienen.",
    selectUsers: "Gebruikers selecteren",
    selectUsersDetails:
      "Als u de selectie van gebruikers uitschakelt, is de enquête beschikbaar voor alle gebruikers. Als u de selectie van gebruikers inschakelt, kunt u meerdere gebruikers in de volgende stap kiezen.",
    linkWithFarms: "Verbinden met boerderijen",
    linkWithFarmsDetails:
      "Indien ingeschakeld, wordt de enquête gekoppeld aan individuele boerderijen. Als een boer meerdere boerderijen heeft, heeft elke boerderij zijn eigen enquête.",
    enabled: "Ingeschakeld",
    disabled: "Uitgeschakeld",
    cancel: "Annuleren",
    next: "Volgende",
    surveySettings: "Enquête-instellingen",

    selectSurveyUsers: "Selecteer enquêtegebruikers",
    selectToProceed: "Selecteer alstublieft gebruiker(s) om door te gaan",
    searchUsers: "Gebruikers zoeken",
    usersSelected: "Geselecteerde gebruikers",
    conditional: "Voorwaardelijk",
    autoConditional: "Automatische Voorwaardelijk",
    userName: "Gebruikersnaam",
    email: "E-mail",
    membershipType: "Lidmaatschapstype",
    membershipValidity: "Geldigheid van het lidmaatschap",
    membershipRemainingDays: "Aantal resterende dagen lidmaatschap",
    membershipRole: "Rol van het lid",
    accountProgress: "Voortgang van het account",
    status: "Toestand",
    active: "Actief",
    deactivated: "Gedeactiveerd",
    continue: "Doorgaan",
    questions: "Vragen",
    questionInfo:
      "De tekst van de beoordelingsvraag die aan de respondent zal worden gepresenteerd.",
    responses: "Antwoorden",
    deleteSurvey: "Enquête verwijderen",
    editSurvey: "Enquête bewerken",
    type: "Type",
    typeInfo:
      "Een keuzemenu om het type invoer te specificeren dat vereist is voor de vraag, zoals keuzerondje, selectievakje of tekstinvoer.",
    compulsory: "Verplicht",
    createSurvey: "Enquête maken",
    surveyBuilder: "Enquêtebouwer",
    surveyList: "Enquêtelijs",
    farm: "Boerderij",
    responseDate: "Datum van antwoord",
    viewSurvey: "Enquête bekijken",
    question: "Vraag",
    settings: "Instellingen",
    addQuestion: "Vraag toevoegen",
    surveysSubmitted: "Ingezonden enquêtes",
    surveyDetail: "Enquêtedetails",
    conditionStatus: "Status van de voorwaarde",
    conditionStatusDesc:
      "Gebruikers die aan de voorwaarden voldoen, komen automatisch in aanmerking voor de enquête.",
    deactivate: "Gedeactiveerd",
    activate: "Activeren",
    serverError: "Er is iets misgegaan. Probeer het later opnieuw.",
    minute: "Minuut",
    perHour: "Per uur",
    day: "Dag",
    enterDescription: "Voer hier uw beschrijving in",
    enterHere: "Voer hier in",
    enterMobile: "Voer mobiel nummer in",
    phoneRequired: "Telefoonnummer is verplicht",
    phoneValid: "Het telefoonnummer moet geldig zijn",
    unableToUpdate: "Niet in staat om bij te werken",
    membershipPlans: "Lidmaatschapsplannen",
    byWeek: "Per week",
    byMonth: "Per maand",
    byYear: "Per jaar",
    custom: "Aangepast",
    name: "Naam",
    regionState: "Regio/Staat",
    provinceState: "Provincie/Staat",
    cityTown: "Stad/Dorp",
    exportAsCSV: "Exporteren als CSV",
    filterBy: "Filteren op",
    autoCondition: "Automatische voorwaarden",
    comingSoon: "Binnenkort beschikbaar",
    userRole: "Gebruikersrol",
    additionalInformationRequired: "Aanvullende informatie vereist",
    back: "Terug",
    browse: "Bladeren",
    clearAll: "ALLES WISSEN",
    description: "Beschrijving",
    selectWeek: "Selecteer week",
    confirm: "BEVESTIGEN",
    selectMonth: "Selecteer maand",
    selectDateRange: "Selecteer datumbereik",
    regionDistrict: "Regio/District",
    address: "Adres",
    familyTribe: "Gemeenschap",
    website: "Website",
    endSurvey: "Enquête beëindigen",
    publishSurvey: "Enquête publiceren",
    copy: "Kopiëren",
    view: "Bekijken",
    startDate: "Startdatum",
    endDate: "Einddatum",
    chooseDate: "Kies datum",
    select: "Selecteren",
    addSurveyQuestion: "Enquêtevraag toevoegen",
    editSurveyQuestion: "Enquêtevraag bewerken",
    questionScore: "Score van de vraag",
    mandatory: "Verplicht",
    yes: "Ja",
    no: "Nee",
    options: "Opties",
    typeHere: "Typ hier",
    add: "Toevoegen",
    optionsHint:
      "Druk op Enter om een antwoord toe te voegen of klik op Toevoegen",
    surveyProgress: "Enquête in uitvoering",
    allResponses: "Samenvatting van alle antwoorden",
    responseQuestion: "Antwoorden per vraag",
    dateSubmitted: "Datum ingediend",
    answer: "Antwoord",
    totalScore: "Totale score",
    score: "Score",
    singleSelection: "Enkele selectie",
    multipleSelection: "Meervoudige selectie",
    if: "Als",
    then: "dan",
    noResponse: "Geen antwoord",
    noSurveyFound: "Geen enquêtes gevonden",
    createNewSurvey:
      'Maak alstublieft een enquête met de knop "Enquête maken" hierboven',
    cannotPublish: "Een uitgeschakelde enquête kan niet worden gepubliceerd!",
    deleteSurveyWarn:
      "Weet u zeker dat u de enquête wilt verwijderen? Als u dit doet, worden alle vragen van de enquête en de antwoorden permanent verwijderd.",
    noQuestionFound: "Geen vragen gevonden",
    createQuestion:
      'Voeg eerst een vraag toe met de knop "Vragen toevoegen" hierboven',
    deleteQuestion: "Weet u zeker dat u de vraag wilt verwijderen?",
    applyChanges: "Hoe wilt u deze wijzigingen toepassen?",
    editFutureSurveys: "ALLEEN TOEKOMSTIGE ENQUÊTES BEWERKEN",
    editLiveSurveyOnly: "ALLEEN ACTIEVE ENQUÊTE BEWERKEN",
    surveyIsLive:
      "Houd er rekening mee dat de enquête momenteel actief is en het bewerken van een vraag op dit moment de eerdere antwoorden kan beïnvloeden. Om problemen te voorkomen, kunt u overwegen een kopie van de enquête te maken om wijzigingen in de vragen aan te brengen.",
    clickToCopy: "Klik hier om een kopie van de enquête te maken",
    applyChangesNow: "WIJZIGINGEN NU TOEPASSEN",
    copySurvey: "Enquête kopiëren",
    changeCopySurveyName:
      "U kunt de naam van de gekopieerde versie van de enquête wijzigen.",
    textField: "Tekstveld",
    textArea: "Tekstgebied",
    textFieldNumeric: "Numeriek tekstveld",
    radioButton: "Radio knop",
    checkBoxes: "Selectievakjes",
    fileAttachment: "Bestandsbijlage",
    digitalSignature: "Digitale handtekening",
    dynamicFarmer: "Dynamische boer",
    dynamicGeofence: "Dynamische geofence",
    dynamicCrop: "Dynamisch gewas",
    dynamicEquipment: "Dynamische apparatuur",

    gpsLocation: "GPS Locatie",
    downloadSurvey: "Enquête Downloaden",
    downloadQuestion: "Alleen Vragen Downloaden",
    downloadResponse: "Alle Antwoorden Downloaden",
    chooseFileFormat: "Bestandsformaat Kiezen",
    surveyTitleLength:
      "De titel van de enquête moet minder dan 100 tekens bevatten",
    selectAllFiltered: "Selecteer alle gefilterde",
    surveyDownloads: "Enquête Downloads",
  },
};
